<template>
	<div class="row">
		<div class="col-12">
			<div class="card">

				<!-- card header -->
				<div class="card-header">
					<h4>Preencha os dados abaixo</h4>

					<a @click="newData" class="btn btn-sm btn-success text-white btn-right">SALVAR</a>
				</div>
				<!-- end card header -->

				<!-- card body -->
				<div class="card-body">

					<!-- form -->
					<h6 class="heading-small text-muted mb-4">Dados</h6>
					<div class="">
						<div class="row">

							<!-- corporate_name -->
							<div class="col-md-6">
								<div class="form-group">
									<label class="form-control-label" for="input-corporate_name">Razão Social</label>
									<input type="text" id="input-corporate_name" v-bind:class="{'is-invalid': errors.corporate_name}"   class="form-control" placeholder="Razão Social" v-model="corporate_name" required="false" >
									<div class="invalid-feedback d-block" v-if="errors.corporate_name">
										<p>{{ errors.corporate_name[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-6 -->
							<!-- end corporate_name -->

							<!-- cnpj -->
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-control-label" for="input-cnpj">CNPJ</label>
									<input type="tel" id="input-cnpj" v-bind:class="{'is-invalid': errors.cnpj}"  maxlength="30" class="form-control" placeholder="CNPJ" v-model="cnpj" required="false" v-mask="'##.###.###/####-##'">
									<div class="invalid-feedback d-block" v-if="errors.cnpj">
										<p>{{ errors.cnpj[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-3 -->
							<!-- end cnpj -->

							<!-- company_type_id -->
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-control-label" for="input-company_type_id">Tipo de Empresa</label>
									<select type="text" id="input-company_type_id" v-bind:class="{'is-invalid': errors.company_type_id}" class="form-control" placeholder="Tipo de Empresa" v-model="company_type_id" required="true" data-toggle="select">
										<option v-for="item, index in companytypes" :key="index" :value="item.id">{{item.name}}</option>
									</select>
									<div class="invalid-feedback d-block" v-if="errors.company_type_id">
										<p>{{ errors.company_type_id[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-3 -->
							<!-- end company_type_id -->

							<!-- cep -->
							<div class="col-md-2">
								<div class="form-group input-group-merge">
									<label class="form-control-label" for="input-cep">CEP</label>
									<div class="input-group">
										<input type="text" v-bind:class="{'is-invalid': errors.cep}"  maxlength="20" class="form-control" placeholder="CEP" v-model="cep" required="true">
										<div class="input-group-append">
											<button class="btn btn-outline-secondary" @click="searchCEP()" type="button" id="button-addon2"><i class="fas fa-search"></i></button>
										</div>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-2 -->
							<!-- end cep -->

							<!-- address -->
							<div class="col-md-5">
								<div class="form-group">
									<label class="form-control-label" for="input-address">Endereço</label>
									<input type="text" id="input-address" v-bind:class="{'is-invalid': errors.address}"   class="form-control" placeholder="Endereço" v-model="address" required="false" >
									<div class="invalid-feedback d-block" v-if="errors.address">
										<p>{{ errors.address[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-6 -->
							<!-- end address -->

							<!-- number -->
							<div class="col-md-2">
								<div class="form-group">
									<label class="form-control-label" for="input-number">Nº</label>
									<input type="text" id="input-number" v-bind:class="{'is-invalid': errors.number}"  maxlength="100" class="form-control" placeholder="Nº" v-model="number" required="false" >
									<div class="invalid-feedback d-block" v-if="errors.number">
										<p>{{ errors.number[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-2 -->
							<!-- end number -->

							<!-- complement -->
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-control-label" for="input-complement">Complemento</label>
									<input type="text" id="input-complement" v-bind:class="{'is-invalid': errors.complement}"   class="form-control" placeholder="Complemento" v-model="complement" required="false" >
									<div class="invalid-feedback d-block" v-if="errors.complement">
										<p>{{ errors.complement[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-4 -->
							<!-- end complement -->

							<!-- neighborhood -->
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-control-label" for="input-neighborhood">Bairro</label>
									<input type="text" id="input-neighborhood" v-bind:class="{'is-invalid': errors.neighborhood}"   class="form-control" placeholder="Bairro" v-model="neighborhood" required="false" >
									<div class="invalid-feedback d-block" v-if="errors.neighborhood">
										<p>{{ errors.neighborhood[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-4 -->
							<!-- end neighborhood -->

							<!-- state -->
							<div class="col-md-2">
								<div class="form-group">
									<label class="form-control-label" for="input-state">Estado</label>
									<v-select :options="states" label="Sigla" v-bind:class="{'is-invalid': errors.state}" v-model="state" :reduce="Sigla => Sigla.ID" @input="validateCities()"></v-select>
									<div class="invalid-feedback d-block" v-if="errors.state">
										<p>{{ errors.state[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-2 -->
							<!-- end state -->

							<!-- city -->
							<div class="col-md-4">
								<div class="form-group">
									<label class="form-control-label" for="input-city">Cidade</label>
									<v-select :options="cities" label="Nome" v-bind:class="{'is-invalid': errors.city}" :reduce="Nome => Nome.ID" v-model="city"></v-select>
									<div class="invalid-feedback d-block" v-if="errors.city">
										<p>{{ errors.city[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-4 -->
							<!-- end city -->

							<!-- country -->
							<div class="col-md-3">
								<div class="form-group">
									<label class="form-control-label" for="input-country">País</label>
									<input type="text" id="input-country" v-bind:class="{'is-invalid': errors.country}"   class="form-control" placeholder="País" v-model="country" required="false" >
									<div class="invalid-feedback d-block" v-if="errors.country">
										<p>{{ errors.country[0] }}</p>
									</div>
								</div><!-- form group -->
							</div><!-- col-md-3 -->
							<!-- end country -->

						</div>
					</div>
					<!-- end form -->

				</div><!-- card body -->
			</div><!-- card -->
		</div><!-- col-12 -->

		<vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
	</div><!-- row -->
</template>

<script>
	import ApiService from '../../apiservice.js';
	export default {
		mixins: [ApiService],
		data() {
			return {
				corporate_name: "",
				country: "",
				cnpj: "",
				address: "",
				number: "",
				complement: "",
				neighborhood: "",
				city: "",
				state: "",
				cep: "",
				company_type_id: "",
				companytypes: [],
				errors: [],
				message: "",
				loading: false,
				fullPage: true,
				cities: [],
				states: [],
				tempCities: []
			}
		},
		mounted() {
			this.loadCompanyTypes();
			this.loadCities();
			this.loadStates();
		},
		methods: {
			loadCities(){
        let _this = this;
        axios.get('/js/cities.min.json').then((res) => {
          _this.tempCities = res.data;
        }).catch((err) => {
          console.log(err);
        });
      },
      loadStates(){
        let _this = this;
        axios.get('/js/states.min.json').then((res) => {
          _this.states = res.data;
        }).catch((err) => {
          console.log(err);
        });
      },
			newData() {
				let _this = this;
				_this.errors = [];
				_this.message = "";
				_this.loading = true;

				let dataInfo = {
					"corporate_name" : _this.corporate_name,
					"country" : _this.country,
					"cnpj" : _this.cnpj,
					"address" : _this.address,
					"number" : _this.number,
					"complement" : _this.complement,
					"neighborhood" : _this.neighborhood,
					"city" : _this.city,
					"state" : _this.state,
					"cep" : _this.cep,
					"company_type_id" : _this.company_type_id,
					"last": ""
				};
				axios.post("/admin/workplaces", dataInfo).then((res) => {

					_this.loading = false;
					_this.resetForm();

					//call function in ApiService to validate success
					_this._api_validateSuccess(res,true);

				}).catch((err) => {

					_this.loading = false;

					if (err.response.data.errors){
						//set errors
          	_this.errors = err.response.data.errors;
					}

					//call function in ApiService to validate error
					_this._api_validateError(err);

				});
			},
			searchCEP(){
				axios.get("https://viacep.com.br/ws/"+this.cep+"/json").then((res) => {
					this.address = res.data.logradouro;
					this.neighborhood = res.data.bairro;
					this.state = res.data.uf;
					this.validateCities();
					this.city = res.data.localidade;
				});
			},
			resetForm() {
				this.corporate_name = '';
				this.country = '';
				this.cnpj = '';
				this.address = '';
				this.number = '';
				this.complement = '';
				this.neighborhood = '';
				this.city = '';
				this.state = '';
				this.cep = '';
				this.company_type_id = '';
			},
			loadCompanyTypes() {
				let _this = this;
				_this.loading = true;
				axios.get("/admin/companytypes").then((res) => {
					_this.companytypes = _this.companytypes.concat(res.data);
					_this.loading = false;
				}).catch((err) => {
					_this.loading = false;
				});
			},
			validateCities(){
        let _this = this;
        _this.cities = [];
        _this.tempCities.map((row) => {
          if (row.Estado == _this.state.ID){
            _this.cities.push(row);
          }
        });
      }
		}
	}
</script>
